<template>
  <div class="uploader">
    <input type="file" accept="image/*" ref="file" @change="chooseImage" />
  </div>
</template>

<script>
import { isWeixin, basepath, appid, getQueryString, appidFn, getCookie } from '../../assets/common/js/config'
import waptoken from '../../assets/common/js/wapid'
export default {
  name: "skinAnalysis",
  data() {
    return {
      uploadUrl: null
    }
  },
  created () {
    let uploadUrl = this.$route.query.orgtype == 'juzi' ? 'Wxmall/YiYuanApickys/filePut' : 'Wxmall/YiYuanApi/filePut'

    this.uploadUrl = basepath + uploadUrl

  },
  methods: {
    currentFile () {
      this.$refs.file.click()
    },
    chooseImage () {
      let This = this, fileList = this.$refs.file.files, formData = new FormData(), AppId, token;

      if (this.$route.query.orgtype == 'juzi') {
        AppId = 6
        token = waptoken.waptoken
      } else {
        if (isWeixin()) {
          if (getCookie('wxmalltoken')) {
            AppId =  appidFn() > -1 ? appidFn() : 1
          } else {
            if (getQueryString('pt') == 'xcx') {
              AppId = 4
            }
          }
          token = appid
        } else {
          if (getQueryString('pt') == 'app') {
            AppId = 2
            token = appid
          } else if (getQueryString('pt') == 'ckapp') {
            AppId = 5
            token = appid
          } else {
            let wapid = waptoken.waptoken
            AppId = 3
            token = wapid
          }
        }
      }

      formData.append('appid', AppId)
      formData.append('tn', new Date().getTime())
      formData.append('sign', new Date().getTime())
      formData.append('token', token)

      formData.append('file', fileList[0])
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      // 新建请求
      const xhr = new XMLHttpRequest()

      xhr.open('POST', This.uploadUrl, true)
      xhr.send(formData)

      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 304) {
          let datas = JSON.parse(xhr.responseText)
          if (datas.code === 0) {
            This.$emit('uploadSuccess', datas.filename)
          } else if (datas.code == 19998) {
            this.$toast('照片不符合要求')
          } else {
            this.$toast('请稍后重试')
          }
        } else {
          this.$toast('请稍后重试')
        }
        this.$toast.clear();
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/skinAnalysis/uploadFile.vue